import React from 'react';
import {Container} from 'react-bootstrap';

import {withPage} from '#pages';
import {Header} from '#components/header';

import linkedinHeadshot from '#media/site-images/linkedin-profile.jpg';

export const Home = withPage(() => {
  return (
    <Container className="home--container"> 
      <img className="home--headshot"  src={linkedinHeadshot} />
      
      <Header className="home--header" title="Nick Bull" />

      <section class="about--section">
        <p>
          Passionate software developer with 10 years of experience. A motivated adaptable learner, who is used to delivering quality results under pressure. Planned and managed multiple software projects from requirements to architecture to delivery. Strong communication skills, experienced in liaising with clients as well as mentoring peers.
        </p>
      </section> 
    </Container>
  );
});
